import useElement from "backend/hooks/elements/useElement";
import { useAppContext } from "qpr-base/context/AppCtxProvider";
import useLink from "qpr-base/hooks/useLink";
import React from "react";

const Perspective = () => {
  const ctx = useAppContext();
  const link = useLink();
  const { data } = useElement(ctx.elementId);

  React.useEffect(() => {
    link({ meaId: data?.parent_element_id });
  }, [data]);
  if (!data) return null;

  return <div />;
};

export default Perspective;
